module.exports = ".app-root {\n  padding: 20px 0;\n  min-width: 1860px; }\n"